import { render, staticRenderFns } from "./MessageConfigurator.vue?vue&type=template&id=34d5216f"
import script from "./MessageConfigurator.vue?vue&type=script&lang=js"
export * from "./MessageConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports